import React, { useCallback, useEffect, useState } from 'react';
import API from '../Api/api';
import './CaptchaField.css';

const CaptchaField = ({ value, onChange, onValidChange }) => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [challenge, setChallenge] = useState(null);
  const [answer, setAnswer] = useState(value || '');

  const loadChallenge = useCallback(async () => {
    try {
      const res = await API.get('/auth/captcha-challenge');
      if (res.data?.enabled) {
        setChallenge({ id: res.data.id, code: res.data.code });
        setAnswer('');
        onChange?.({ captcha_id: '', captcha_answer: '' });
        onValidChange?.(false);
      }
    } catch {
      setChallenge(null);
    }
  }, [onChange, onValidChange]);

  useEffect(() => {
    let mounted = true;
    API.get('/auth/captcha-config')
      .then((res) => {
        if (!mounted) return;
        const isEnabled = !!res.data?.enabled;
        setEnabled(isEnabled);
        if (isEnabled) loadChallenge();
        else onValidChange?.(true);
      })
      .catch(() => onValidChange?.(true))
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, [loadChallenge, onValidChange]);

  useEffect(() => {
    setAnswer(value || '');
  }, [value]);

  if (loading || !enabled) return null;

  const handleAnswerChange = (next) => {
    setAnswer(next);
    const payload = {
      captcha_id: challenge?.id || '',
      captcha_answer: next,
    };
    onChange?.(payload);
    onValidChange?.(!!next.trim() && !!challenge?.id);
  };

  return (
    <div className="captcha-field">
      <label htmlFor="captcha-answer">Security check</label>
      <div className="captcha-field__row">
        <div className="captcha-field__code" aria-label="CAPTCHA code">
          {challenge?.code || '······'}
        </div>
        <button type="button" className="captcha-field__refresh" onClick={loadChallenge}>
          Refresh
        </button>
      </div>
      <input
        id="captcha-answer"
        type="text"
        inputMode="text"
        autoComplete="off"
        spellCheck="false"
        placeholder="Enter the characters shown above"
        value={answer}
        onChange={(e) => handleAnswerChange(e.target.value)}
      />
      <p className="captcha-field__hint">Letters and numbers are not case-sensitive.</p>
    </div>
  );
};

export default CaptchaField;
